import React from 'react';
// import 'bootstrap.css';
import '@mescius/wijmo.styles/wijmo.css';
import * as wjChart from '@mescius/wijmo.react.chart'
import { getData, palette } from './data';

interface Idata {
  [key: string]: any
}

interface IParetoChart {
  yTitle: string;
  xTitle: string;
  data: Idata[];
}

const ParetoChart: React.FC<IParetoChart> = ({ xTitle, yTitle, data }) => {
  // console.log(data)
  // // Sort the data based on x-axis values
  // const sortedRows = [...data].sort((a, b) => {
  //   const aValue = a.x;
  //   const bValue = b.x;

  //   // Handle numbers
  //   if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
  //     return Number(aValue) - Number(bValue);
  //   }

  //   // Handle dates
  //   const aDate = new Date(aValue);
  //   const bDate = new Date(bValue);
  //   if (!isNaN(aDate.getTime()) && !isNaN(bDate.getTime())) {
  //     return aDate.getTime() - bDate.getTime();
  //   }

  //   // Handle strings and other types
  //   return String(aValue).localeCompare(String(bValue));
  // });

  // console.log(sortedRows)

  const rows = getData(data);

  return (<div className="container-fluid">
    {/* <div className="form-group">
      <button id="btnUpdate" className="btn btn-default" onClick={updateData}>Update</button>
    </div> */}
    <wjChart.FlexChart itemsSource={rows} palette={palette} chartType="Column" binding="x" bindingX='x'>
      <wjChart.FlexChartAxis wjProperty="axisY" format="n0" title={yTitle} axisLine={true} />
      <wjChart.FlexChartAxis wjProperty="axisX" labelAngle={-45} binding="x" />
      <wjChart.FlexChartLegend position="None" />
      <wjChart.FlexChartSeries binding="y" name={yTitle} />
      {/* <wjChart.FlexChartSeries binding="cummulative" name="Cumulative %" chartType="LineSymbols" style={{ 'stroke': 'orange', 'strokeWidth': 4 }}>
        <wjChart.FlexChartAxis wjProperty="axisY" position="Right" title="Cumulative %" format="p0" min={0} axisLine={true}/>
      </wjChart.FlexChartSeries> */}
    </wjChart.FlexChart>
  </div>)
}

export default ParetoChart